var exports = {
  "k": "x04b3a21e--7cc8cf--container",
  "z": "x04b3a21e--7cc8cf--container--gray",
};

module.exports = exports;
